export default configurationGuid => `/catalog/configurator/editmandi?configurationGuid=${configurationGuid}`;
